<template>
  <div>
    <!--  BEGIN NAVBAR  -->
    <div class="header-container fixed-top">
      <header class="header navbar navbar-expand-sm">
        <!-- Portal vue for Breadcrumb -->
        <!-- <portal-target name="breadcrumb" style="margin-left: 30px; font-size: 10px"> </portal-target> -->

        <img src="@/assets/images/logo.png" alt="" style="width: 200px" />

        <div class="navbar-item flex-row ml-md-auto">
          <!-- 积分 -->
          <div class="score-item" @click="showDialog">{{ allscore }}</div>
          <!-- 语言选择 -->
          <!-- <b-dropdown toggle-tag="a" variant="icon-only" toggle-class="nav-link" class="nav-item language-dropdown">
            <template #button-content>
              <img v-if="selectedLang" src="@/assets/images/layout/global.png" class="head-icon" alt="flag" />
            </template>
            <perfect-scrollbar>
              <b-dropdown-item v-for="item in countryList" :key="item.code" link-class="d-flex align-items-center" :active="$i18n.locale === item.code" @click.prevent="changeLanguage(item)">
                <img :src="require(`@/assets/images/flags/${item.code}.png`)" class="head-icon" alt="" /> <span>{{ item.name }}</span>
              </b-dropdown-item>
            </perfect-scrollbar>
          </b-dropdown> -->

          <!-- 下载中心 -->
          <!-- <a class="language-dropdown d-flex align-items-center" href="javascript:;" @click="toDownload()">
            <img class="head-icon" src="@/assets/images/layout/download.png" alt="" id="download" />
          </a> -->
          <!-- 消息 -->

          <!-- 通知 -->
          <!-- <el-dropdown class="nav-item notification-dropdown language-dropdown align-items-center d-flex">
            <span>
              <img v-if="noticePageList.length == 0" class="head-icon" src="@/assets/images/layout/notice.svg" alt="" />
              <img v-else class="head-icon" src="@/assets/images/layout/notice-red.svg" alt="" />
            </span>
            <el-dropdown-menu slot="dropdown" style="width: 250px">
              <div class="notic-title">
                <div>通知</div>
                <a @click="seeMore">查看所有通知</a>
              </div>
              <div v-for="(item, index) in noticePageList" :key="index">
                <div class="notic-content" @click="viewDetails(item.param, item.path, item.id)">
                  <div class="notic-dian"></div>
                  <div class="notice">{{ item.message }}</div>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- 分割线 -->
          <!-- <div class="split-line"></div> -->
          <!-- 个人中心 -->
          <b-dropdown toggle-tag="a" variant="icon-only" toggle-class="user nav-link" class="nav-item user-profile-dropdown ml-0" :right="true">
            <template #button-content>
              <img src="@/assets/images/layout/avatar.png" alt="avatar" />
              <!-- <span class="username ml-2">{{ account.account ? account.account.nickName : '' }}</span> -->
            </template>
            <b-dropdown-item @click="showPersonalCenter">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-user"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              {{ $t('common.personal_center') }}
            </b-dropdown-item>
            <!-- <b-dropdown-item @click="showPasswordDrawer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-settings"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                ></path>
              </svg>
              {{ $t('common.change_password') }}
            </b-dropdown-item> -->
            <b-dropdown-divider></b-dropdown-divider>
            <!-- <b-dropdown-item @click="isOpen = !isOpen">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-settings"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                ></path>
              </svg>
              {{ $t('system_preferences') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider> -->
            <b-dropdown-item @click="logOut">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-log-out"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              {{ $t('common.logout') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </header>
    </div>
    <!--  面包屑导航  -->
    <!-- 侧边栏菜单显示时展示面包屑导航 -->
    <!-- <div class="sub-header-container">
      <header class="header navbar navbar-expand-sm">
        <a
          href="javascript:void(0);"
          class="sidebarCollapse ml-3"
          data-placement="bottom"
          @click="$store.commit('toggleMenuStyle', $store.state.menu_style == 'vertical' ? 'collapsible-vertical' : 'vertical')"
        >
          <img src="@/assets/images/layout/expand.svg" alt="" style="height: 32px" />
        </a>

        <a href="javascript:void(0);" class="sidebarCollapse ml-2" data-placement="bottom" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)">
          <img v-show="$store.state.is_show_sidebar" src="@/assets/images/layout/close.png" alt="" style="height: 32px" />
          <img v-show="!$store.state.is_show_sidebar" src="@/assets/images/layout/open.png" alt="" style="height: 32px" />
        </a>
      </header>
    </div> -->

    <!--  横向菜单展示  -->
    <!-- <div id="topbar-global" class="topbar-nav header navbar" role="banner">
      <nav class="topbar">
        <ul class="list-unstyled menu-categories" id="topAccordion">
          <li v-for="item in menu" :key="item.id" class="menu single-menu" :class="activeId == item.id ? 'active' : ''">
            <a v-if="item.type == 1" href="javascript:;" class="dropdown-toggle autodroprown" @click="addStyle(item)">
              <router-link tag="li" :to="'/' + item.path" style="align-self: center">
                <a href="javascript:;">
                  <div>
                    <i v-if="item.icon" :data-feather="item.icon"></i>
                    <span>{{ $t(item.name) }}</span>
                  </div>
                </a>
              </router-link>
            </a>
            <a v-if="item.type == 0" href="javascript:;" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle autodroprown">
              <div>
                <i v-if="item.icon" :data-feather="item.icon"></i>
                <span>{{ $t(item.name) }}</span>
              </div>
              <svg-to-down></svg-to-down>
            </a>
            <ul v-if="item.type == 0" class="collapse submenu list-unstyled" data-parent="#topAccordion" @click="addStyle(item)">
              <component v-for="child in item.children" :key="child.id" :is="getComponentName(child.type)" :data="child" :path="'/' + item.path + '/' + child.path"></component>
            </ul>
          </li>
        </ul>
      </nav>
    </div> -->
    <!-- 偏好设置 -->
    <div>
      <div class="app-settings" :class="{ active: isOpen }">
        <perfect-scrollbar class="sidbarchat p-3" tag="div">
          <a class="btn-close" href="javascript:;" @click="isOpen = !isOpen">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </a>
          <div class="text-center">
            <img src="https://s3.cn-northwest-1.amazonaws.com.cn/kiwi-dsp/logo/logo-loop.gif" alt="" style="width: 50%" />
          </div>
          <h5 class="mb-0 text-center">Kiwi One Connect</h5>
          <p class="text-center">{{ $t('preference.setpreference') }}</p>
          <hr />

          <h6 class="mb-1">{{ $t('preference.colorScheme') }}</h6>
          <!-- <p class="small text-muted mb-3">Overall light or dark presentation.</p> -->
          <p class="small text-muted mb-3"></p>
          <div class="btn-group-toggle row mb-4 mx-0">
            <!-- <b-radio v-model="$store.state.dark_mode" class="text-color radio-primary col-6 pl-0 mb-3 btn-check" value="light" @change="setTemplateStyle"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-sun mr-2"
              >
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>

              Light Mode</b-radio> -->
            <!-- <b-radio v-model="$store.state.dark_mode"
              class="text-color radio-primary col-6 pl-0 mb-3 btn-check" value="dark" @change="setTemplateStyle"><svg
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-moon mr-2">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
              Dark Mode</b-radio> -->
            <b-radio v-model="$store.state.dark_mode" class="text-color radio-primary col-6 pl-0 mb-3 btn-check" value="light" @change="setTemplateStyle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-airplay mr-2"
              >
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
              {{ $t('preference.lightMode') }}</b-radio
            >
            <b-radio v-model="$store.state.dark_mode" class="text-color radio-primary col-6 pl-0 mb-3 btn-check" value="dark" @change="setTemplateStyle"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-moon mr-2"
              >
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
              {{ $t('preference.darkMOde') }}</b-radio
            >
            <!-- <b-radio v-model="$store.state.dark_mode" disabled class="text-color radio-primary col-12 pl-0 btn-check" value="system" @change="setTemplateStyle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-airplay mr-2"
              >

                <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                <polygon points="12 15 17 21 7 21 12 15"></polygon>
              </svg>
              System
            </b-radio> -->
          </div>
          <h6 class="mb-1">{{ $t('preference.navigationPosition') }}</h6>
          <!-- <p class="small text-muted mb-3">Select the primary navigation paradigm for your app.</p> -->
          <p class="small text-muted mb-3"></p>
          <div class="btn-group-toggle row mb-4 mx-0">
            <b-radio v-model="$store.state.menu_style" class="text-color radio-primary col-6 pl-0 mb-3 btn-check" value="collapsible-vertical" @change="setMenuStyle">{{
              $t('preference.collapsible')
            }}</b-radio>
            <b-radio v-model="$store.state.menu_style" class="text-color radio-primary col-6 pl-0 mb-3 btn-check" value="vertical" @change="setMenuStyle">{{ $t('preference.vertical') }}</b-radio>
            <b-radio v-model="$store.state.menu_style" class="text-color radio-primary col-12 pl-0 btn-check" value="horizontal" @change="setMenuStyle">{{ $t('preference.horizontal') }}</b-radio>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
    <!-- 个人中心 -->
    <el-drawer :with-header="false" :visible.sync="drawerVisible" @close="cancelForm" :size="500" destroy-on-close>
      <div class="drawer__content">
        <div class="text-center mt-5">
          <img src="@/assets/images/user_avatar.svg" alt="avatar" style="width: 120px" />
          <div style="font-size: 1.875rem">{{ account.account ? account.account.nickName : '' }}</div>
        </div>
        <el-form class="user-form" ref="form" :rules="rules" :model="form" :hide-required-asterisk="true">
          <el-form-item :label="$t('user.account')" prop="nickName">
            <el-input v-model="form.nickName" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.phone')" prop="mobile">
            <el-input v-model="form.mobile" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.password')" prop="password">
            <div class="password-disabled">********</div>
            <div class="modify-password" @click="pwdDrawerVisible = true">修改</div>
          </el-form-item>
          <el-form-item :label="$t('user.email')" prop="email">
            <div style="width: 100%; padding-left: 15px; clear: both; color: #88929f">{{ form.email }}</div>
            <!-- <el-input v-model="form.email" :disabled="true"></el-input> -->
          </el-form-item>
          <div class="drawer__footer">
            <el-button class="light mr-2" @click="cancelForm">{{ $t('common.cancel') }}</el-button>
            <el-button class="mr-4" :loading="submitting" @click="submitForm">{{ $t('common.confirm') }}</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <!-- 修改密码 -->
    <el-drawer :with-header="false" :visible.sync="pwdDrawerVisible" @close="cancelPwdForm" :size="500" destroy-on-close>
      <div class="drawer__content d-flex flex-column">
        <div style="padding: 20px 60px; margin-top: 120px; font-size: 1.875rem; color: #ffffff">{{ $t('common.change_password') }}</div>
        <el-form class="user-form" ref="pwdForm" :rules="rules" :model="pwdForm" :hide-required-asterisk="true">
          <el-form-item :label="$t('user.old_password')" prop="oldPassword">
            <el-input show-password v-model="pwdForm.oldPassword" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.new_password')" prop="password">
            <el-input show-password v-model="pwdForm.password" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.confirm_password')" prop="rePassword">
            <el-input show-password v-model="pwdForm.rePassword" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <div class="drawer__footer">
            <el-button class="light mr-2" @click="cancelPwdForm">{{ $t('common.cancel') }}</el-button>
            <el-button class="mr-4" :loading="submitting" @click="submitPwdForm">{{ $t('common.confirm') }}</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>

    <el-dialog :visible.sync="dialogVisible" width="768px" top="10vh">
      <div class="score-wrap">
        <div class="score-title">积分明细</div>
        <div class="score-overview">
          <div class="score-width">
            剩余积分
            <div class="score-value">{{ $store.state.score.score.points }}</div>
          </div>
          <div>=</div>
          <div class="score-width">
            每日赠送积分
            <div class="score-value">{{ $store.state.score.score.dailyPoints }}</div>
          </div>
          <div>+</div>
          <div class="score-width">
            购买积分
            <div class="score-value">{{ $store.state.score.score.purchasePoints }}</div>
          </div>
          <div>+</div>
          <div class="score-width">
            系统赠送
            <div class="score-value">{{ $store.state.score.score.systemGiftPoints }}</div>
          </div>
        </div>
        <div class="score-filter">
          <div :class="['filter-item', { active: item.value == scoreFilter }]" v-for="item in scoreFilterConfig" :key="item.value" @click="changeScoreFilter(item.value)">{{ item.label }}</div>
        </div>
        <div class="score-flow" @scroll="handleScroll">
          <div class="score-flow-item" v-for="item in scoreFlow" :key="item.score">
            <div>
              <div>{{ item.operationTypeName }}</div>
              <div class="score-flow-time">{{ item.createTime }}</div>
            </div>
            <div>{{ item.flowType != 1 ? '+' : '-' }}{{ item.points }}</div>
          </div>
        </div>
        <div class="score-rule">
          <div class="score-rule-title">积分规则:</div>
          <div>1.每日登录后赠送100积分，赠送积分未使用完时，在当日23:59:59清零。</div>
          <div>2.购买积分和系统赠送积分，永久有效，不兑换不折现，注销账户清零。</div>
        </div>

        <el-tooltip class="item" effect="dark" content="敬请期待" placement="top">
          <div class="score-buy-btn">去购买积分</div>
        </el-tooltip>
        <!-- <div class="image-wrap">
          <div class="image-inner">
            <img :src="previewImage.image.url" alt="" />
          </div>
        </div>
        <div class="info-wrap">
          <div class="info-inner">
            <div class="info-title">原图</div>
            <div class="info-desc text-center">
              <img :src="previewImage.task.sourceUrl" alt="" style="max-width: 120px; max-height: 120px" />
            </div>
            <div class="info-title">描述词</div>
            <div class="info-desc">{{ previewImage.task.prompt }}</div>
            <div class="info-title">画面比例</div>
            <div class="info-desc">比例 {{ previewImage.task.scale }}</div>
            <div class="info-desc mt-0">尺寸 {{ previewImage.task.width }}px*{{ previewImage.task.height }}px</div>
            <div class="info-title">生成时间</div>
            <div class="info-desc">{{ previewImage.task.createTime }}</div>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="action-btn download-btn">下载</div>
          <div class="action-btn remove-btn">删除</div>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import feather from 'feather-icons';
import { mapGetters, mapActions, mapMutations } from 'vuex';
// import svgToDown from '../myComponent/svgToDown.vue';
// import childLiHorizontal from './components/childLiHorizontal.vue';
// import childLink from './components/childLink.vue';
import { noticeSetRead, editPassWord, queryScoreFlowDetail, editAccount } from '@/service';
import { debounce } from '@/utils/util';

const passwordValidate = (rule, value, callback) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,12}$/;
  if (!regex.test(value)) {
    callback(new Error('密码必须包含大小写字母、数字及字符,长度至少8个字符'));
  }
  callback();
};

export default {
  // components: {
  //   svgToDown,
  //   childLiHorizontal,
  //   childLink,
  // },
  data() {
    return {
      selectedLang: null,
      countryList: this.$store.state.countryList,
      activeId: 0,
      isOpen: null,
      timestamp: '',
      drawerVisible: false,
      // 表单
      form: {
        nickName: '',
        email: '',
        mobile: '',
      },
      pwdDrawerVisible: false,
      pwdForm: {
        oldPassword: '',
        password: '',
        rePassword: '',
      },
      submitting: false,
      dialogVisible: false,
      scoreFilterConfig: [
        { label: '全部', value: 0 },
        { label: '消耗', value: 1 },
        { label: '购买', value: 2 },
        { label: '获得', value: 3 },
      ],
      scoreFilter: 0,
      scoreFlow: [],
      offset: 1,
      totalPages: 0,
    };
  },
  computed: {
    ...mapGetters({
      account: 'accountInfo/account',
      // menu: 'accountInfo/menu',
      noticePageList: 'notice/noticePageList',
      allscore: 'score/allscore',
    }),
    rules() {
      return {
        nickName: [
          { required: true, message: this.$t('user.rules.nickName'), trigger: 'blur' },
          { min: 2, message: this.$t('user.rules.nickName_invalid'), trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: this.$t('user.rules.phone'), trigger: 'blur' },
          { pattern: /^\d{2,30}$/, message: this.$t('user.rules.phone_invalid'), trigger: 'blur' },
        ],
        oldPassword: [
          { required: true, message: this.$t('user.rules.old_password'), trigger: 'blur' },
          { min: 6, message: this.$t('user.rules.password_invalid'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('user.rules.password'), trigger: 'blur' },
          {
            trigger: 'change',
            validator: passwordValidate,
          },
        ],
        rePassword: [
          { required: true, message: this.$t('user.rules.re_password'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value != this.pwdForm.password) {
                callback(new Error(this.$t('user.rules.re_password_invalid')));
              }
              callback();
            },
          },
        ],
      };
    },
  },
  watch: {
    // menu() {
    //   this.$nextTick(() => {
    //     feather.replace();
    //   });
    // },
    '$route.path': {
      handler: function (val) {
        let a = val === '/user/info' || val === '/system/download/index' || val === '/users/systemNotification';
        if (a) {
          this.activeId = 0;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.selectedLang = this.$appSetting.toggleLanguage();
    this.toggleMode();
    this.setTemplateStyle();
    this.setMenuStyle();
    this.setLayoutStyle();
    this.setScoreAsync();
  },
  methods: {
    ...mapActions({
      setnoticePageAsync: 'notice/setnoticePageAsync',
      setScoreAsync: 'score/setScoreAsync',
    }),
    ...mapMutations({
      updateAccount: 'accountInfo/updateAccount',
    }),
    handleScroll: debounce(function (event) {
      // 输出滚动的位置
      console.log(`Scroll position: ${event.target.scrollTop} px`);
      const div = event.target;
      if (div.scrollTop + div.clientHeight >= div.scrollHeight - 150) {
        if (this.offset < this.totalPages) {
          this.offset++;
          this.fetchScoreFlow();
        }
      }
    }),
    viewDetails(param, path, id) {
      this.$router.push({
        path: path,
        query: {
          advertiserId: param,
        },
      });
      this.setRead(id);
      this.setnoticePageAsync();
    },
    /**
     * 标记已读
     */
    setRead(id) {
      const params = {
        id: id,
      };
      noticeSetRead(params)
        .then((res) => {
          if (res.code != 200) {
            this.$message.error(res.message);
            return;
          }
          this.setnoticePageAsync();
        })
        .finally(() => {});
    },

    addStyle(item) {
      this.activeId = item.id;
    },
    seeMore() {
      this.$router.push({ path: '/users/systemNotification' });
    },
    toggleMode(mode) {
      this.$appSetting.toggleMode(mode);
    },
    changeLanguage(item) {
      this.selectedLang = item;
      this.$appSetting.toggleLanguage(item);
    },
    toDownload() {
      this.$router.push({ path: '/system/download/index' });
    },
    getComponentName(type) {
      return type == 0 ? 'child-li-horizontal' : 'child-link';
    },
    /**
     * 登出
     */
    logOut() {
      // doAccountLogout().finally(() => {
      //   });
      localStorage.removeItem('authToken');
      sessionStorage.removeItem('$account');
      this.$router.push({ path: '/auth/login' });
    },
    imgLoadEvent() {
      setTimeout(() => {
        this.timestamp = Date.now();
      }, 8000);
    },
    setTemplateStyle() {
      this.$store.commit('toggleDarkMode', this.$store.state.dark_mode);
    },

    setMenuStyle() {
      this.$store.commit('toggleMenuStyle', this.$store.state.menu_style);
    },

    setLayoutStyle() {
      this.$store.commit('toggleLayoutStyle', this.$store.state.layout_style);
    },
    /**
     * 个人中心
     */
    showPersonalCenter() {
      console.log(this.account);
      const { userName, mobile, account } = this.account.account;
      this.drawerVisible = true;
      this.form = {
        nickName: userName,
        mobile,
        email: account,
      };
    },
    /**
     * 取消
     */
    cancelForm() {
      this.drawerVisible = false;
      this.form = {
        nickName: '',
        email: '',
        mobile: '',
      };
      this.$refs.form.resetFields();
    },
    /**
     * 提交表单
     */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (!valid) return false;
        this.submitting = true;
        const params = {
          accountId: this.account.account.id,
          userName: this.form.nickName,
          mobile: this.form.mobile,
        };
        editAccount(params)
          .then(() => {
            this.$message.success(this.$t('common.success'));
            this.updateAccount(
              Object.assign(
                {
                  ...this.account.account,
                },
                {
                  userName: this.form.nickName,
                  mobile: this.form.mobile,
                }
              )
            );
          })
          .finally(() => {
            this.cancelForm();
            this.submitting = false;
          });
      });
    },
    /**
     * 修改密码
     */
    showPasswordDrawer() {
      this.pwdDrawerVisible = true;
    },
    /**
     * 取消
     */
    cancelPwdForm() {
      this.pwdDrawerVisible = false;
      this.pwdForm = {
        oldPassword: '',
        password: '',
        rePassword: '',
      };
      this.$refs.pwdForm.resetFields();
    },
    /**
     * 提交表单
     */
    submitPwdForm() {
      this.$refs['pwdForm'].validate((valid) => {
        if (!valid) return false;
        this.submitting = true;
        const params = {
          oldPassword: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.password,
        };
        editPassWord(params)
          .then(() => {
            this.$message.success(this.$t('common.success'));
            this.cancelPwdForm();
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    showDialog() {
      this.dialogVisible = true;
      this.changeScoreFilter(0);
    },
    changeScoreFilter(val) {
      this.scoreFilter = val;
      this.offset = 1;
      this.fetchScoreFlow();
    },
    fetchScoreFlow() {
      const params = {
        limit: 10,
        offset: this.offset,
        flowType: this.scoreFilter ? this.scoreFilter : undefined,
      };
      queryScoreFlowDetail(params).then((res) => {
        if (res.code == 200) {
          this.scoreFlow = this.offset == 1 ? [...res.data.records] : this.scoreFlow.concat(res.data.records);
          this.totalPages = res.data.pages;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/base/base.scss';

.notice {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 20px;
  letter-spacing: 2px;
}

.notic-dian {
  width: 6px;
  height: 6px;
  background: #ff647c;
  border-radius: 50px;
  margin-right: 8px;
  margin-top: 6px;
}

.notic-content {
  display: flex;
  align-content: center;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 400;
  color: #0b132b;
  cursor: pointer;
  // white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}

.notic-title {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 8px 20px;

  div {
    font-size: 13px;
    font-weight: 400;
    color: #0b132b;
  }

  a {
    font-size: 12px;
    font-weight: 400;
    color: #5e75fb !important;
    cursor: pointer;
  }
}

.notic-content:hover {
  background-color: rgba(235, 235, 235, 0.4);
}

// 点击查看详情样式
.clickStyle {
  color: #3b59db;
}

.aStyle {
  // display: inline-block;
  float: right;
}

.dropItem {
  display: flex;
  justify-content: flex-end;
}

// 浅色
.header-container .navbar {
  height: 56px;
  background-color: transparent;

  // overflow: hidden;
  .navbar-logo {
    height: 20px;
  }

  .head-icon {
    width: 22px !important;
    height: 22px !important;
  }

  .split-line {
    width: 0.5px;
    height: 32px;
    margin: 6px 20px;
    background-color: #eef8ff;
  }

  .username {
    color: #ffffff;
  }
}

.sub-header-container {
  top: 40px;

  .navbar {
    height: 32px;
    min-height: 32px;
    background-color: #ffffff;

    // box-shadow: none;
    .sidebarCollapse {
      padding: 4px 0 0;
    }
  }
}

#topbar-global {
  top: 40px;

  &:hover {
    .menu-categories {
      height: 54px;
    }
  }

  .menu-categories {
    height: 32px;
    transition: all 0.3s linear;

    .single-menu {
      &:hover {
        & > a span {
          color: $primary-color;
        }
      }

      > a {
        padding: 0;

        span {
          font-size: 13px;
        }
      }

      ::v-deep .submenu li {
        &:hover {
          > a {
            color: $primary-color;
          }
        }

        a {
          font-size: 13px;
        }
      }
    }
  }
}

.fixed-top {
  left: 240px;
  top: 8px;
  transition: all 0.5s ease-out;
}

.collapsible-vertical .fixed-top {
  left: 28px;
}

.user-form {
  padding: 0 60px;
  ::v-deep {
    label {
      margin-bottom: 0;
    }
    .el-input__inner {
      border-color: transparent;
      background-color: #2b313a;
      color: #ffffff;
    }
    .el-input__count .el-input__count-inner {
      background-color: transparent;
    }
    .el-input.is-disabled .el-input__inner {
      border-color: transparent;
    }
  }
}

// 深色
// .header-container .navbar {
//   height: 40px;
//   background-color: #7b61ff;
//   // overflow: hidden;
//   .navbar-logo {
//     height: 20px;
//   }
//   .head-icon {
//     width: 20px;
//   }
//   .split-line {
//     width: 0.5px;
//     height: 32px;
//     margin: 6px 20px;
//     background-color: #eef8ff;
//   }
//   .username {
//     color: #ffffff;
//   }
// }
// .sub-header-container {
//   top: 40px;
//   .navbar {
//     height: 32px;
//     min-height: 32px;
//     background-color: #fff;
//     // box-shadow: none;
//     .sidebarCollapse {
//       padding: 4px 0 0;
//     }
//   }
// }
.score-item {
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0 12px 0 28px;
  margin-right: 20px;
  border-radius: 14px;
  border: 1px solid #9eff0c;
  color: #ffffff;
  background: url('~@/assets/images/icon/score.svg') no-repeat;
  background-position: 9px center;
  cursor: pointer;
}
.score-wrap {
  position: relative;
  padding: 18px 36px;
  border-radius: 18px;
  background: #212530;
  .score-title {
    font-size: 20px;
    color: #ffffff;
  }
  .score-overview {
    display: flex;
    justify-content: space-around;
    width: auto;
    padding: 18px;
    margin-top: 12px;
    font-size: 16px;
    color: #ffffff;
    background: #0d1116;
    border-radius: 18px;
    .score-width {
      width: 17%;
      overflow: hidden;
      text-align: center;
    }
    .score-value {
      margin-top: 16px;
      color: #9eff0c;
      font-size: 20px;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .score-filter {
    display: flex;
    margin-top: 20px;
    .filter-item {
      width: 80px;
      height: 38px;
      line-height: 38px;
      margin-right: 12px;
      border-radius: 20px;
      border: 1px solid #333a45;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      &.active {
        border-color: #9eff0c;
        color: #9eff0c;
      }
    }
  }
  .score-flow {
    width: auto;
    height: 220px;
    padding: 12px;
    margin-top: 12px;
    background: #0d1116;
    border-radius: 18px;
    overflow: auto;
    .score-flow-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 1px dashed #333a45;
      color: #ffffff;
      font-size: 16px;
      &:last-child {
        border-bottom: none;
      }
      .score-flow-time {
        color: #88929f;
        font-size: 10px;
      }
    }
  }
  .score-rule {
    margin-top: 12px;
    color: #88929f;
    font-size: 12px;
    .score-rule-title {
      margin-bottom: 5px;
      color: #ffffff;
    }
  }
  .score-buy-btn {
    position: absolute;
    bottom: 18px;
    right: 36px;
    width: 148px;
    height: 36px;
    line-height: 36px;
    background: linear-gradient(192deg, #9eff0c 0%, #43d1a7 100%);
    border-radius: 23px;
    color: #0d1116;
    text-align: center;
  }
}
.password-disabled {
  width: 100%;
  height: 40px;
  padding-left: 15px;
  clear: both;
  background: #2b313a;
  color: #ffffff;
  border-radius: 8px;
}
.modify-password {
  position: absolute;
  right: 0;
  top: 0;
  color: #9eff0c;
  cursor: pointer;
}
</style>
